const reportStatus = {
  WaitingSurvey: 1,
  WaitingReview: 2,
  WaitingResults: 3,
  Cancelled: 4,
  Completed: 5,
  OrderLabsFirst: 6,
  OrderOnHold: 7,
  LabsWaitingSurvey: 8,
  FinalProcessing: 9
}

export default reportStatus;